const CorrectOverlay = ({ bool }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "40vh",
        left: "calc(50% - 10vh)",
        height: "20vh",
        width: "20vh",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {bool && (
        <div
          style={{
            width: "15vh",
            height: "15vh",
            border: "1.5vh solid #2DF034",
            borderRadius: "50%", // 원형
            position: "relative", // 내부 라인들 절대 배치용
            cursor: "pointer",
          }}
        >
          {/* 체크 표시(두 개의 라인을 각각 배치) */}
          {/* 첫 번째 라인: 왼쪽 아래에서 중앙까지 */}
          <div
            style={{
              position: "absolute",
              width: "35%",
              height: "10%",
              backgroundColor: "#2DF034",
              borderRadius: "5px",
              bottom: "25%", // 약간 아래
              left: "50%",
              transform: "rotate(-135deg)",
              transformOrigin: "left bottom",
            }}
          />
          {/* 두 번째 라인: 중앙에서 오른쪽 위로 */}
          <div
            style={{
              position: "absolute",
              width: "60%",
              height: "10%",
              backgroundColor: "#2DF034",
              borderRadius: "5px",
              bottom: "20%",
              left: "45%",
              transform: "rotate(-50deg)",
              transformOrigin: "left bottom",
            }}
          />
        </div>
      )}
      {!bool && (
        <div
          style={{
            width: "15vh",
            height: "15vh",
            border: "1.5vh solid #FF4444",
            borderRadius: "50%", // 원형
            position: "relative", // 내부 라인들 절대 배치용
            cursor: "pointer",
          }}
        >
          {/* X 모양을 그리는 선 2개 */}
          <div
            style={{
              position: "absolute",
              width: "75%", // X 선의 너비
              height: "10%", // X 선의 두께
              backgroundColor: "#FF4444",
              borderRadius: "5px", // X 선의 둥글기
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(45deg)",
            }}
          />
          <div
            style={{
              position: "absolute",
              width: "75%",
              height: "10%",
              backgroundColor: "#FF4444",
              borderRadius: "5px",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(-45deg)",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CorrectOverlay;
